const DIET_TYPE = {
  OrderItemDiet: 'OrderItemDiet',
  OrderItemDayDiet: 'OrderItemDayDiet',
  OrderItemDayAddon: 'OrderItemDayAddon',
  OrderItemDayDish: 'OrderItemDayDish',
  OrderItemDayModification: 'OrderItemDayModification',
  OrderItemDayDelivery: 'OrderItemDayDelivery',
  DietItem: 'DietItem',
  BagModification: 'BagModification',
  BuyBag: 'BuyBag',
} as const;

export default DIET_TYPE;
